import { Component } from '@angular/core';

@Component({
    selector: 'app-user-avatar',
    template: `
        <div class="btn-icon" id="nav-user-avatar">
            <i class="fa-solid fa-user"></i>
        </div>
    `,
    styles: [
        `
            @import 'src/scss/variables.scss';

            #nav-user-avatar {
                width: $top-nav-user-icon-size;
                height: $top-nav-user-icon-size;
                background: #ebf0f4;

                i {
                    color: var(--app-highlight-darker);
                    font-size: 20px;
                }
            }
        `,
    ],
    standalone: true,
})
export class UserAvatarComponent {}
